import axios from 'axios';
import { constant } from '../../constant';

// Dedicated client for the SEO admin API. Uses validateStatus:()=>true so 4xx
// responses resolve (rather than throw) — callers inspect res.status and read
// res.data.errors to surface server-side validation messages (e.g. redirect
// guardrail failures) in the UI.
const client = axios.create({ baseURL: constant.baseUrl, validateStatus: () => true });

const authHeaders = () => ({ Authorization: localStorage.getItem('token') });

// ---- Pages ----
export const getPages = () => client.get('seo/pages', { headers: authHeaders() });
export const getPageDetail = (path) =>
  client.get('seo/pages/detail', { headers: authHeaders(), params: { path } });
export const saveDraft = (path, seo) =>
  client.put('seo/pages/draft', { path, seo }, { headers: authHeaders() });
export const publishPage = (path) =>
  client.post('seo/pages/publish', { path }, { headers: authHeaders() });
export const revertPage = (path, changeLogId) =>
  client.post('seo/pages/revert', { path, changeLogId }, { headers: authHeaders() });

// ---- History ----
export const getHistory = (params) =>
  client.get('seo/history', { headers: authHeaders(), params });

// ---- Blog SEO ----
// The blog routes accept JSON bodies (the upload middleware only engages on
// multipart requests), so the SEO editor saves the SEO slice without touching
// the post's content or images.
export const listBlogPosts = () => client.get('blog/all', { headers: authHeaders() });
export const getBlogPost = (idOrSlug) =>
  client.get(`blog/${idOrSlug}`, { headers: authHeaders() });
export const saveBlogSeo = (id, body) =>
  client.put(`blog/${id}`, body, { headers: authHeaders() });
export const publishAllBlogs = () =>
  client.post('seo/blogs/publish-all', {}, { headers: authHeaders() });

// ---- Redirects ----
export const listRedirects = () => client.get('seo/redirects', { headers: authHeaders() });
export const createRedirect = (body) =>
  client.post('seo/redirects', body, { headers: authHeaders() });
export const updateRedirect = (id, body) =>
  client.put(`seo/redirects/${id}`, body, { headers: authHeaders() });
export const deleteRedirect = (id) =>
  client.delete(`seo/redirects/${id}`, { headers: authHeaders() });

export default {
  getPages,
  getPageDetail,
  saveDraft,
  publishPage,
  revertPage,
  getHistory,
  listBlogPosts,
  getBlogPost,
  saveBlogSeo,
  publishAllBlogs,
  listRedirects,
  createRedirect,
  updateRedirect,
  deleteRedirect,
};
